import React from 'react';
import { BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO } from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { getPoliticallyExposedPersonLabel } from '../../../../../services/bond-insurance';
import { DateToStringDate } from '../../../../../services/date';
import { maskCpfOrCnpj, maskMoney, maskPhoneNumber } from '../../../../../services/masks';
import { FieldLabel } from '../../../../../styles';

export type Props = {
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value?: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsuranceNaturalTenantDetails = (props: Props) => {
  const { naturalTenant } = props.bondInsurance;

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        {naturalTenant.has_social_name ? (
          <>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="NOME" value={naturalTenant.main_tenant_name} />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay
                label="NOME SOCIAL"
                value={naturalTenant.main_tenant_social_name}
              />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay label="GÊNERO" value={naturalTenant.main_tenant_gender} />
            </div>
          </>
        ) : (
          <>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay label="NOME" value={naturalTenant.main_tenant_name} />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay label="GÊNERO" value={naturalTenant.main_tenant_gender} />
            </div>
          </>
        )}
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="CPF"
            value={maskCpfOrCnpj(naturalTenant.main_tenant_cpf)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DATA DE NASCIMENTO"
            value={DateToStringDate(naturalTenant.main_tenant_birth_date)}
          />
        </div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="E-MAIL" value={naturalTenant.main_tenant_email} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="TELEFONE"
            value={
              naturalTenant.main_tenant_phone
                ? maskPhoneNumber(naturalTenant.main_tenant_phone)
                : 'Não informado'
            }
          />
        </div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="NOME DA MÃE"
            value={naturalTenant.main_tenant_mother_name}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="ESTADO CIVIL"
            value={naturalTenant.main_tenant_marital_status}
          />
        </div>
      </div>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="CÔNJUGE COMPÕE RENDA"
            value={naturalTenant.partner_rent_composition ? 'Sim' : 'Não'}
          />
        </div>
        {naturalTenant.partner_rent_composition && (
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay label="NOME (CÔNJUGE)" value={naturalTenant.partner_name} />
          </div>
        )}
        {!naturalTenant.partner_rent_composition && (
          <div style={{ flex: 1, boxSizing: 'border-box' }}></div>
        )}
      </div>
      {naturalTenant.partner_rent_composition && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="CPF (CÔNJUGE)"
              value={maskCpfOrCnpj(naturalTenant.partner_cpf)}
            />
          </div>
        </div>
      )}
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="VÍNCULO EMPREGATÍCIO"
            value={naturalTenant.employment_relationship}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DATA DE ADMISSÃO"
            value={
              naturalTenant.employment_admission_date
                ? DateToStringDate(naturalTenant.employment_admission_date)
                : ''
            }
          />
        </div>
      </div>

      {!naturalTenant.resident && (
        <>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="RESIDIRÁ NO IMÓVEL?"
                value={naturalTenant.resident ? 'Sim' : 'Não'}
              />
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
              <FieldDisplay
                label="NOME DO RESIDENTE"
                value={naturalTenant.resident_name}
              />
            </div>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="DATA DE NASC. DO RESIDENTE"
                value={DateToStringDate(naturalTenant.resident_birth_date)}
              />
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, boxSizing: 'border-box' }}>
              <FieldDisplay
                label="CPF DO RESIDENTE"
                value={
                  naturalTenant.resident_cpf
                    ? maskCpfOrCnpj(naturalTenant.resident_cpf)
                    : 'Não informado'
                }
              />
            </div>
          </div>
        </>
      )}

      {naturalTenant.include_sympathise_tenants &&
        naturalTenant.sympathise_tenants.map((tenant, index) => (
          <div
            key={`sympathiser-${index}`}
            style={{
              marginTop: '1.5em',
              borderTop: '1px dashed #ccc',
              paddingTop: '1em'
            }}
          >
            <FieldLabel
              style={{
                color: '#364445',
                fontSize: '1.0em',
                fontWeight: 'bold',
                marginBottom: '1em'
              }}
            >{`${index + 1}º LOCATÁRIO SOLIDÁRIO`}</FieldLabel>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="NOME" value={tenant.name} />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay label="GÊNERO" value={tenant.gender} />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="CPF" value={maskCpfOrCnpj(tenant.cpf)} />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="DATA DE NASCIMENTO"
                  value={
                    tenant.birth_date
                      ? DateToStringDate(new Date(tenant.birth_date))
                      : 'Indisponível'
                  }
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="NACIONALIDADE" value={tenant.nationality} />
              </div>
              {tenant.rg ? (
                <div style={{ flex: 1, boxSizing: 'border-box' }}>
                  <FieldDisplay label="RG" value={tenant.rg} />
                </div>
              ) : (
                <div style={{ flex: 1, boxSizing: 'border-box' }}></div>
              )}
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="E-MAIL" value={tenant.email} />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="TELEFONE"
                  value={
                    tenant.phone || tenant.cellphone
                      ? maskPhoneNumber(tenant.phone || tenant.cellphone || '')
                      : 'Não informado'
                  }
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="NOME DA MÃE" value={tenant.mother_name} />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="ESTADO CIVIL"
                  value={tenant.marital_status || tenant.maritalStatus}
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="RESIDENTE?"
                  value={tenant.resident ? 'Sim' : 'Não'}
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="PESSOA POLITICAMENTE EXPOSTA"
                  value={getPoliticallyExposedPersonLabel(tenant.politically_exposed_person)}
                />
              </div>
              {tenant.politically_exposed_person === 'CLOSE_TO' && (
                <div style={{ flex: 1, boxSizing: 'border-box' }}>
                  <FieldDisplay
                    label="NOME DA PESSOA POLITICAMENTE EXPOSTA"
                    value={
                      tenant.close_to_politically_exposed_person
                        ?.politically_exposed_person_name
                    }
                  />
                </div>
              )}
            </div>
            {tenant.politically_exposed_person === 'CLOSE_TO' && (
              <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                  <FieldDisplay
                    label="CPF DA PESSOA POLITICAMENTE EXPOSTA"
                    value={
                      tenant.close_to_politically_exposed_person
                        ?.politically_exposed_person_cpf
                        ? maskCpfOrCnpj(
                            tenant.close_to_politically_exposed_person
                              .politically_exposed_person_cpf
                          )
                        : ''
                    }
                  />
                </div>
                <div style={{ flex: 1, boxSizing: 'border-box' }}>
                  <FieldDisplay
                    label="GRAU DE PARENTESCO DA PESSOA POLITICAMENTE EXPOSTA"
                    value={
                      tenant.close_to_politically_exposed_person
                        ?.degree_of_kinship_to_politically_exposed_person
                    }
                  />
                </div>
              </div>
            )}
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="VÍNCULO EMPREGATÍCIO"
                  value={tenant.employment_relationship}
                />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="PROFISSÃO"
                  value={tenant.profession || 'Indisponível'}
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="RENDA MENSAL"
                  value={
                    tenant.monthly_fixed_income
                      ? maskMoney(`${tenant.monthly_fixed_income}`, true)
                      : 'Indisponível'
                  }
                />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="OUTRAS RENDAS"
                  value={maskMoney(`${tenant.other_incomes || 0}`, true)}
                />
              </div>
            </div>
          </div>
        ))}

      {naturalTenant.partners &&
        naturalTenant.partners.map((partner, index) => (
          <div
            key={`partner-${index}`}
            style={{
              marginTop: '1.5em',
              borderTop: '1px dashed #ccc',
              paddingTop: '1em'
            }}
          >
            <FieldLabel
              style={{
                color: '#364445',
                fontSize: '1.0em',
                fontWeight: 'bold',
                marginBottom: '1em'
              }}
            >{`${index + 1}º SÓCIO`}</FieldLabel>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay label="NOME" value={partner.name} />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay label="CPF" value={maskCpfOrCnpj(partner.document)} />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="RENDA (%)"
                  value={partner.percent ? `${partner.percent} %` : 'NÃO INFORMADO'}
                />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="DATA DE ENTRADA"
                  value={DateToStringDate(partner.date_of_entry)}
                />
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
